import React, { useEffect, useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { NavLink } from "react-router-dom"
import useInit from './hooks/useInit'
import Page from 'shared/types/Page'
import SubMenu from 'shared/components/SubMenu'

interface MenuItemCollapseProps {
    label: string,
    link: string,
    icon?: any,
    iconActive?: any,
    isActive?: boolean
    pages?: Page[]
    currentPage: Page | null
    setCurrentPage?: Function
}

const MenuItemCollapse: React.FunctionComponent<MenuItemCollapseProps> = (props) => {

    const [subMenuPages, setSubMenuPages] = useState<any>([])
    const [showSubmenu, setShowSubmenu] = useState<any>(false)
    const [showSubmenuClick, setShowSubmenuClick] = useState<any>(false)
    const [activeClass, setActiveClass] = useState<any>('')
    const [icon, setIcon] = useState<any>('')
    
    useInit({
        setSubMenuPages,
        setShowSubmenu,
        setActiveClass,
        setIcon,
        curLink: props.link,
        curIcon: props.icon,
        curIconActive: props.iconActive,
        isActive: props.isActive,
        pages: props.pages,
        label: props.label,
        curPage: props.currentPage
    })

    return (
        <>
            <li className="menu-item">
                <NavLink
                    to='javascript:return false;'
                    className={"nav-link" + activeClass}
                    onClick={(e) => {
                        if (showSubmenu) {
                            setShowSubmenuClick(false)
                        }
                        setShowSubmenuClick(!showSubmenuClick)
                        setShowSubmenu(false)
                        e.preventDefault()
                    }}
                >
                    {icon}
                    <span>{props.label}</span>
                </NavLink>
            </li>
            <Collapse in={showSubmenuClick}>
                <li className={"menu-item" + (showSubmenu ? ' show' : '') }>
                    {subMenuPages.length > 0 ? 
                        <SubMenu 
                            pages={subMenuPages} 
                            currentPage={props.currentPage} 
                            setCurrentPage={props.setCurrentPage}
                        /> : ''}
                </li>
            </Collapse>
        </>
    );
}

export default MenuItemCollapse;